<template name="能耗洞察">
  <div class="flex-row">
    <CompSideTree 
      :include-sub-nodes="includeSubNodes"
      pageName="energyAnalysis"
      :showOrgFilter="true"
      :showIncludeSubNode="true"
      @update:includeSubNodes="(val) => (includeSubNodes = val)"
      @update:treeOption="(val) => (treeOption = val)"
      :treeData="treeData"
      :treeOption="treeOption"
      ref="treeRef"
      :permissionObj="permissionObj"
      @checkChange="handleCheckChange"
      @nodeClick="nodeClick"
      @organizationChange="handleOrganizationChange"
      ></CompSideTree>

    <div class="flex-col" style="min-width: 857px;">
      <breadcrumb :repeat="true" v-if="website.setting.breadcrumb" />
      <div class="energyAnalysis-bgcard">

        <div class="global-filter-condition-row">
          <SearchBar ref="searchBar" :isAnalysis="true" @change="handleSearchChange" />
          <el-dropdown>
            <comp-button v-if="permissionObj.export" type="info" size="medium">
              <span class="export-btn">
                <comp-svg name="up-export" size="20px" style="margin-right: 8px;"></comp-svg>
                {{ Lang.btn.export }}
              </span>
            </comp-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="handleExport(1)"
                  >{{ Lang.label.timeInColumns }}
                </el-dropdown-item>
                <el-dropdown-item @click="handleExport(2)"
                  >{{ Lang.label.timeInRows }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
        <!-- 折线图 -->
        <el-row class="line-chart-box">
          <div class="chart-title-row">
            <div style="display: flex;justify-content: space-between; margin-right: 20px; align-items: center">
              <chartTitle :title="Lang.label.energyinsightTrend" style="font-family: Roboto-Bold;"></chartTitle>
              
              
            </div>
            <div class="toolbox-row">
              <Toolbox unit="kWh" :types="['groupBar', 'line', 'lineArea', 'stackedBar', 'table']" @click="changeChrtType" />
            </div>
          </div>
          <LineChartArea :unit="globalUnit" v-if="chartType==='lineArea'" chartType="lineArea" :title="Lang.graph.energyCostTrend" ref="lineArea" @refresh="refreshChange" :style="{ height: halfContentHeight }"></LineChartArea>
          <LineChart :unit="globalUnit" v-if="chartType==='line'" chartType="line" :title="Lang.graph.energyCostTrend" ref="line" @refresh="refreshChange" :style="{ height: halfContentHeight }"></LineChart>
          <GroupBarChart :unit="globalUnit" v-if="chartType==='groupBar'" :dataType="dataType" :chartType="chartType" :title="Lang.graph.energyCostTrend" ref="groupBar" @refresh="refreshChange" :style="{ height: halfContentHeight }"></GroupBarChart>
          <GroupStackedBarChart :unit="globalUnit" v-if="chartType==='stackedBar'" :chartType="chartType" :title="Lang.graph.energyCostTrend" ref="stackedBar" @refresh="refreshChange" :style="{ height: halfContentHeight }"></GroupStackedBarChart>
          <div v-if="chartType==='table'" class="hide_avue_crud_header energyAnalysis-chart-table" :style="{ height: halfContentHeight }">
            <avue-crud
                :option="option"
                v-model:search="search"
                :table-loading="loading"
                :data="tableData"
                ref="crud"
                v-model="form"
                :fit="true"
                :permission="permissionObj"
                :before-open="beforeOpen"
                v-model:page="page"
                @search-change="searchChange"
                @search-reset="searchReset"
                @selection-change="selectionChange"
                @current-change="currentChange"
                @size-change="sizeChange"
                @refresh-change="refreshChange"
                @on-load="onLoad"
              >
              </avue-crud>
          </div>
        </el-row>
        <div class="pie-bar-box" :key="chartKey" :style="{height: halfContentHeight}">
          <div class="pie-chart-box" style="min-width: 512px;">
            <pieChart
              :unit="globalUnit"
              :title="Lang.label.energyinsightProportion"
              ref="pieChart">
            </pieChart>
          </div>
          <div class="bar-chart-box">
            <barChart
              :unit="globalUnit"
              :title="Lang.label.energyinsightRanking"
               ref="barChart">
            </barChart>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getUser,
} from '@/api/system/user';
import { 
  getProjectTree,
 } from '@/api/project/project';
 import { anlysisDimensionTree, getDimensionTree } from '@/api/system/dimension';

import { mapGetters } from 'vuex';
import website from '@/config/website';
import { getToken } from '@/utils/auth';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import func from '@/utils/func';
import SearchBar from './comps/searchBar.vue';
import LineChart from './comps/lineChart.vue';
import LineChartArea from './comps/lineChartArea.vue';
import pieChart from './comps/pieChart.vue';
import barChart from './comps/barChart.vue';
import Toolbox from './comps/toolbox.vue';
import chartTitle from './comps/chartTitle.vue';
import GroupBarChart from './comps/groupBar.vue';
import GroupStackedBarChart from './comps/groupStackedBar.vue';
import { download } from '@/axios';
import { debounce } from 'lodash';
import CompSideTree from '@/components/comp-side-tree/index.vue';
import { separator, setSeparatorToFixed3 } from '@/utils/format.js';




export default {
  components: {
    SearchBar,
    LineChart,
    LineChartArea,
    GroupBarChart,
    GroupStackedBarChart,
    pieChart,
    barChart,
    Toolbox,
    chartTitle,
    CompSideTree
  },
  data() {
    return {
      globalUnit: 'kWh',
      halfContentHeight: '316px',
      chartKey: 0,
      chartType: 'groupBar',
      dataType: '',
      form: {},
      dataZoom: {
        start: 0,
        end: 40,
      },
      search: {},
      searchQuery: '',
      roleBox: false,
      includeSubNodes: false,
      excelBox: false,
      platformBox: false,
      initFlag: true,
      auditMode: false,
      selectionList: [],
      query: {},
      loading: true,
      platformLoading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      platformPage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      init: {
        roleTree: [],
        deptTree: [],
      },
      props: {
        label: 'title',
        value: 'key',
      },
      roleGrantList: [],
      roleTreeObj: [],
      treeNodeId: '',
      treeFirstNodeId: '',
      treeData: [],
      tableData: [],
      treeOption: {
        nodeKey: 'id',
        multiple: true,
        defaultExpandAll: false,
        filterText: this.Lang.tips.plzInputFilterText,
        lazy: false,
        filter: false,
        checkStrictly: false,
        props: {
          labelText: this.Lang.tips.title,
          label: 'title',
          value: 'id',
          children: 'children',
        },
        treeLoad: function (node, resolve) {
          const params = {
            dimensionType: 'AreaEnergy',
            deptId: this.userInfo.dept_id,
          }
          getProjectTree(params).then(res => {
            resolve(
              res.data.data.map(item => {
                return {
                  ...item,
                  leaf: !item.children,
                };
              })
            );
          });
        },
        addBtn: false,
        menu: false,
        size: 'small',
      },
      option: {
        // height: 252,
        calcHeight: 92, // 表格的高度增加量，默认为自动高度。如果设置为auto，会自适应窗口高度。
        tip: false,
        fit: true,
        // showOverflowTooltip: true,
        searchShow: true, // 搜索栏
        searchMenuSpan: 6,
        // searchGutter: 12,
        border: false, // 每行的竖线
        index: true,
        indexLabel: this.Lang.table.serialNumber,
        indexWidth: '120px',
        selection: false, // 选择
        menuWidth: 310, // 操作列宽
        addBtn: false, // 添加
        viewBtn: true, // 查看
        editBtn: true, // 编辑
        delBtn: true, // 删除
        menu: false,
        menuType: 'button',
        menuTitle: this.Lang.label.operation,
        menuHeaderAlign: 'right', // 操作按钮样式
        dialogType: 'drawer',
        dialogClickModal: false,
        column: [ // 表格列
        ],
      },
      data: [],

      excelForm: {},
      excelOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: this.Lang.tips.templateUpload,
            prop: 'excelFile',
            type: 'upload',
            drag: true,
            loadText: this.Lang.tips.templateUploadingPlzWait,
            span: 24,
            propsHttp: {
              res: 'data',
            },
            tip: this.Lang.tips.plzUploadStandarFile,
            action: '/blade-system/user/import-user',
          },
          {
            label: this.Lang.tips.dataCover,
            prop: 'isCovered',
            type: 'switch',
            align: 'center',
            width: 80,
            dicData: [
              {
                label: this.Lang.label.no,
                value: 0,
              },
              {
                label: this.Lang.label.yes,
                value: 1,
              },
            ],
            value: 0,
            slot: true,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzSelectIfCover,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.tips.templateDownload,
            prop: 'excelTemplate',
            formslot: true,
            span: 24,
          },
        ],
      },
    };
  },
  watch: {
    'form.tenantId'() {
      if (this.form.tenantId !== '' && this.initFlag) {
        this.initData(this.form.tenantId);
      }
    },
    'excelForm.isCovered'() {
      if (this.excelForm.isCovered !== '') {
        const column = this.findObject(this.excelOption.column, 'excelFile');
        column.action = `/blade-system/user/import-user?isCovered=${this.excelForm.isCovered}`;
      }
    },
  },
  computed: {
    ...mapGetters(['menuItem', 'permission', 'userInfo']),
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
        }
      }))
      console.log('页面权限', obj)
      return obj
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  mounted() {
    // 非租户模式默认加载管理组数据
    if (!website.tenantMode) {
      this.initData(website.tenantId);
    }
    this.getTreeData();
    this.handleChangeSubNode(this.includeSubNode)
    this.calcContentHeight()
  },
  methods: {
    calcContentHeight() {
      const clientHeight = document.body.clientHeight - 244;
      let halfContentHeight = clientHeight / 2;
      if (halfContentHeight < 220) {
        halfContentHeight = 220
      }
      this.option.height = halfContentHeight - 28;
      this.halfContentHeight = halfContentHeight + 'px';
    },
    handleOrganizationChange(id) {
      this.organization = id;
      this.getTreeData(id)
    },
    handleChangeSubNode(val) {
      this.treeOption.checkStrictly = !val;
    },
    changeChrtType(type) {
      this.chartType = type;
      // console.log('chartType', type)
      if (type === 'table') {
        // this.tableData = this.trendData;
      } else {
        this.$nextTick(() => {
          this.$refs[type].updateChart(this.trendData)
        })
      }
    },
    // 点击搜索按钮时触发
    onSearch() {
      this.filterTree(this.treeData, this.searchQuery);
    },
    // 根据搜索词过滤树形结构数据
    filterTree(data, query) {
      const result = [];

      function traverse(nodes) {
        for (let node of nodes) {
          const lowerCaseName = node.name.toLowerCase();
          const lowerCaseQuery = query.toLowerCase();

          if (lowerCaseName.includes(lowerCaseQuery)) {
            result.push({ ...node });
          } else if (node.children && node.children.length) {
            const childResult = [];
            traverse(node.children, childResult);

            if (childResult.length) {
              result.push({
                ...node,
                children: childResult
              });
            }
          }
        }
      }

      traverse(data);
      this.filteredData = result;
    },
    // 搜索
    handleSearchChange(params) {
      this.dataType = params.dataType;
      if (params.dataType == 5) {
        this.dataZoom = {
          start: 0,
          end: 40,
        }
      } else {
        this.dataZoom = {
          start: 0,
          end: 100,
        }
      }
      this.query = Object.assign(this.query, params);
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
    },
    // 获取左侧树
    getTreeData(deptId) {
      const params = {
        dimensionType: 'AreaEnergy',
        deptId: deptId || this.userInfo.dept_id
      }
      getDimensionTree(params).then(res => {
        const treeData = res.data.data;
        this.treeData = treeData;
        const item = treeData[0] || {}
        if (item.unit) {
          this.treeFirstNodeId = item.id;
        }
        this.$nextTick(() => {
          const tree = this.$refs.treeRef;
          tree?.autoClickFirstNode()
        })
      }).catch(e => {
        if (/localhost:2888/g.test(location.origin)) {
          // this.setTestTreeData()
        }
      })
    },
    debouncedCheckChange: debounce(function(checkedKeys, checkedNodes) {
      this.nodeCheckChange(checkedKeys, checkedNodes);
    }, 300), // 300毫秒内只执行最后一次
    // 多选功能
    handleCheckChange({checkedKeys, checkedNodes}) {
      this.nodeCheckChange(checkedKeys, checkedNodes);
    },
    nodeCheckChange(checkedKeys, checkedNodes) {
      this.page.currentPage = 1;
      this.$refs.searchBar.resetDefaultValue(); // 切换项目重置初始日期
      const param = this.$refs.searchBar.getParams();
      param.dimensions = this.getDimensions(checkedNodes);
      this.query = Object.assign(this.query, param);
      this.onLoad(this.page, param);
    },
    nodeClick({data, checkedNodes}) {
      console.log('nodeClick 能耗洞察');
      this.page.currentPage = 1;
      this.chartKey += 1;
      this.$refs.searchBar.resetDefaultValue(); // 切换项目重置初始日期
      this.checkedNodes = checkedNodes;
      const param = this.$refs.searchBar.getParams();
      // param.dimensionType = data.dimensionType;
      param.dimensions = this.getDimensions(checkedNodes);
      this.query = Object.assign(this.query, param);
      this.onLoad(this.page, param);
    },
    getDimensions(checkedNodes) {
      const dimensions = [];
      if (checkedNodes) {
        this.currentCheckedNodes = checkedNodes;
      }
      const nodes = checkedNodes || this.currentCheckedNodes;
      nodes.forEach(item => {
        dimensions.push({
          "dimensionId": item.id,
          "dimensionName": item.name,
        })
      })
      return dimensions
    },
    initData(tenantId) {
    },
    searchReset() {
      this.query = {};
      this.treeNodeId = '';
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = Object.assign(this.query, param)
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    handleExport(exportType) {
      let url = `/emp-business/energyDimens/exportReport/apiDownload?${
        this.website.tokenHeader
      }=${getToken()}`;
      const { dimensionType, dataType, stime, etime } = this.query;
      let params = {
        stime,
        etime,
        exportType,
        dataType,
        dimensionType,
      };
      params.dimensions = this.getDimensions();

      this.$confirm(this.Lang.tips.ifExportData, this.Lang.label.tips, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      }).then(() => {
        NProgress.start();
        download({url, params}).then(res => {
          NProgress.done();
        });
      });
    },

    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getUser(this.form.id).then(res => {
          this.form = res.data.data;
          if (this.form.hasOwnProperty('deptId')) {
            this.form.deptId = func.split(this.form.deptId);
          }
          if (this.form.hasOwnProperty('roleId')) {
            this.form.roleId = func.split(this.form.roleId);
          }
          if (this.form.hasOwnProperty('postId')) {
            this.form.postId = func.split(this.form.postId);
          }
        });
      }
      this.initFlag = true;
      done();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      const param = this.$refs.searchBar.getParams();
      this.onLoad(this.page, Object.assign(this.query, param));
    },
    onLoad(page, params = {}) {
      const param = {
        ...this.query,
        ...params,
      }
      // if (!param.dimensions?.length) {
      //   this.loading = false;
      //   console.log('无dimensions不请求')
      //   return;
      // }
      this.loading = true;
      anlysisDimensionTree(param).then(res => {
        this.loading = false;
        const data = res.data.data;
        let { trend = [], proportion = [], rank = [] } = data;
        this.globalUnit = data.unit;
        this.trendData = trend; // 保存用于切换图表类型
        this.handleResponseData(trend, {compareType: 0}); // 0同比
        this.$nextTick(() => {
          if (this.$refs[this.chartType]) {
            this.changeChrtType(this.chartType)
          }
          this.$refs.pieChart?.updateChart(proportion);
          this.$refs.barChart?.updateChart(rank);
        })
      });
    },

    handleResponseData(data, param) {
      this.option.column = [];
      const tableData = [];
      const columns = [
        {
          label: this.Lang.table.nodeName,
          prop: 'nodeName',
          minWidth: '180px',
          fixed: 'left',
          search: false,
          display: false, // 弹出表单是否显示
          showOverflowTooltip: true, // 自动展开列宽，内容不换行
        },
      ];
      const columnB = {
        label: `${this.Lang.label.energyinsightConsumption}`,
        minWidth: '120px',
        children: [],
      }
      let commonXvals = []; // 先找出公共x轴日期
      data.forEach((item, colIndex) => {
        if (item.xvals && item.xvals.length) {
          commonXvals = item.xvals;
        }
      });
      this.commonXvals = commonXvals;
      // 创建多级表头
      commonXvals.forEach((day, index) => {
        columnB.children.push({
          label: day,
          prop: 'day' + index,
          minWidth: '130px',
        })
      })
      columns.push(columnB);
      this.option.column = columns;
      // 创建行
      data.forEach((item, colIndex) => {
        const xvals = item.xvals;
        const yvals = item.yvals;
        // yvals.forEach(yval => {
        //   if (yval == '') {
        //     yval = '-';
        //   }
        // })
        const rowData = {}
        xvals.forEach((day, index) => {
          const separatorVal = separator(yvals[index], 3);
          if (yvals[index] !== '') {
            rowData['day'+index] = separatorVal;
          } else {
            rowData['day'+index] = '-';
          }
        })
        tableData.push({
          nodeName: item.dimensionName || item.rtuName,
          ...rowData
        })
      });
      this.showAvueCard = false;
      if (data.length) {
        this.tableData = tableData;
      } else {
        this.tableData = []
      }
      this.showAvueCard = true;
      this.loading = false;
    },

  },
};
</script>

<style lang="scss" scoped>
</style>
